export default function useCopyToClipboard () {
  const setCopyToClipboard = (str: string = '') => {
    const el = document.createElement('textarea');
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  };

  return { setCopyToClipboard };
}
